import { Record } from 'immutable';

const MultiAgencyRecord = Record({
  agencyId: null,
  agencyName: null
});

export class MultiAgency extends MultiAgencyRecord {
  agencyId: string;
  agencyName: string;
}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/models/multi-agency.ts